import React, { createContext, useState, useContext } from 'react';
import uz from '../translations/uz.json';
import en from '../translations/en.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('uz'); // Default to Uzbek

  const translations = {
    uz,
    en,
  };

  /**
   * Get translation for a key
   * @param {string} key - Translation key
   * @returns {string} Translated text
   */
  const t = (key) => {
    return translations[language][key] || key;
  };

  /**
   * Toggle between Uzbek and English
   */
  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'uz' ? 'en' : 'uz'));
  };

  /**
   * Set language directly
   * @param {string} lang - Language code ('uz' or 'en')
   */
  const setLang = (lang) => {
    if (lang === 'uz' || lang === 'en') {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    t,
    toggleLanguage,
    setLang,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

/**
 * Custom hook to use language context
 * @returns {Object} Language context value
 */
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
